module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-neutral-95bcdb5f.svg";